import React from 'react';
import { MapPin } from 'lucide-react';
import { localAttractions } from '../mock';

export const Location = () => {
  return (
    <section id="location" className="py-12 sm:py-16 md:py-20 lg:py-28 bg-[#071936] text-white">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-light text-white mb-3 sm:mb-4">
            Explore the North West Coast
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed px-4">
            From coastal walks and sea views to surf, food, and historic houses, 
            The Tullaghan Pod is a perfect base to experience the quieter beauty of the northwest.
          </p>
        </div>

        {/* Attraction Cards with Images */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-6 max-w-4xl mx-auto">
          {localAttractions.map((attraction) => (
            <div
              key={attraction.name}
              className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg overflow-hidden hover:bg-white/10 transition-all duration-300"
            >
              {attraction.image && (
                <div className="h-48 overflow-hidden">
                  <img 
                    src={attraction.image} 
                    alt={attraction.name}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
              )}
              <div className="p-6 sm:p-8">
                <div className="flex items-start gap-4">
                  <MapPin className="text-[#2AA7A1] flex-shrink-0 mt-1" size={24} strokeWidth={1.5} />
                  <div>
                    <h3 className="text-xl sm:text-2xl font-light text-white mb-2">
                      {attraction.name}
                    </h3>
                    <p className="text-[#2AA7A1] text-sm font-medium mb-3">
                      {attraction.distance}
                    </p>
                    <p className="text-white/70 leading-relaxed text-sm sm:text-base">
                      {attraction.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
